<template>
  <footer class="footer" v-if="!hideFooter">
    <!-- Footer quick links section start -->
    <div class="footer-quick-links">
      <div class="container">
        <div class="columns is-multiline is-mobile justify-content-between">
          <div class="column is-12-mobile is-4-tablet">
            <div class="columns is-mobile">
              <div class="column">
                <h3>About</h3>
                <ul>
                  <li><router-link :to="{ name: 'HelpAndSupport', query: $route.query }" target="_blank">Help &amp; Support</router-link></li>
                  <li><router-link :to="{ name: 'PrivacyPolicy', query: $route.query}" target="_blank">Privacy Policy</router-link></li>
                  <li><router-link :to="{ name: 'TermsConditions', query: $route.query}" target="_blank">Terms &amp; Conditions</router-link></li>
                  <li><router-link :to="{ name: 'Faqs', query: $route.query}" target="_blank">Faqs</router-link></li>
                </ul>
              </div>
              <div class="column" v-if="access_type == 'internal'">
                <h3>Stores</h3>
                <ul>
                  <li><router-link :to="{ name: 'StoreLocations', query: $route.query}">Find a Store</router-link></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-2-tablet">
            <div class="columns is-mobile">
              <div class="column">
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Footer quick links section end -->

    <div class="copyright-section has-text-centered">
      <img class="footer-logo" alt="logo" v-if="vg_businessProfile.branding && vg_businessProfile.branding.logo_url" :src="vg_businessProfile.branding.logo_url" />
      <p>&reg; {{ currentYear }} Powered by <img class="powered-logo" alt="logo" src="@/assets/img/logo.png" /></p>
    </div>
    <div :class="'scroll-top bg-secondary ' + ( showScrollTop ? 'active' : '')" @click.prevent="scrollToTop()">
      <img src="@/assets/img/scroll-top.svg" alt="scroll top" />
    </div>
  </footer>
</template>


<script>
var VueScrollTo = require('vue-scrollto');
import moment from 'moment';
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      access_type: '', 
      showScrollTop: false,
    };
  },
  computed: {
    currentYear() {
      return moment().format("YYYY");
    },
    ...mapGetters({
      vg_businessProfile: "businessprofile/detail",
    }),

    hideFooter() {
      return (this.$route.query['nof'] && ((this.$route.query['nof'] == 1) || (this.$route.query['nof'] == 'true')) ) ? true : false;
      // if(this.$route.query.nof && (this.$route.query.nof == 1) ){
      //   return true;
      // }
      // return false;
    },
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleFooterScroll);
  },
  mounted() {
    if(this.$route.query.access_type){
      this.access_type = this.$route.query.access_type;
    }
     window.addEventListener("scroll", this.handleFooterScroll);
  },
  methods: {
    /**
     * scroll function
     */
    handleFooterScroll() {
      if (window.scrollY > 100) {
        this.showScrollTop = true;
      } else {
        this.showScrollTop = false;
      }
    },
    /**
     * Click function
     */
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
  
    },
  },
};
</script>
